import { SectionColor } from '../types';
import { IAsset } from './assets';

export const EMERGENT = 'emergent';
export const EARLY = 'early';
export const DEVELOPING = 'developing';
export const CONSOLIDATING = 'consolidating';
export const EXTENDING = 'extending';

export const EXEMPLARS = 'exemplars';
export const PLANNING = 'planning';
export const LESSONS = 'lessons';
export const ASSESSMENT = 'assessment';
export const PROFESSIONAL = 'professional';

export const ACCESS_CODE = 'accesscode';

export const NOT_FOUND = 'not-found';

export const ABOUT = 'about-pm-writing';
export const PROCESS = 'the-writing-process';
export const SKILLS = 'writing-skills-and-conventions';
export const PROF_LEARNING_CATEGORIES = [ABOUT, PROCESS, SKILLS];

export const SCOPE = 'scope-and-sequence';
export const PATHWAYS = 'suggested-teaching-pathways';
export const TEXT_TYPES = 'text-types';
export const LITERACY = 'oral-and-visual-literacy';
export const CONVENTIONS = 'writing-skills-and-conventions';
export const PLANNING_CATEGORIES = [SCOPE, PATHWAYS, TEXT_TYPES, LITERACY, CONVENTIONS];

export const PHRASES = 'Phrases';
export const PREPOSITIONAL_PHRASES = 'Prepositional phrases';
export const HIGHLIGHT = 'word-highlight';

export const TEXT_TYPE = 'Text type';
export const LANGUAGE = 'language';

export const SPECIAL_CHARACTERS = [
  '.',
  ',',
  '!',
  '?',
  ':',
  ';',
  '/',
  '\\',
  '@',
  '<',
  '>',
  '~',
  '#',
  '%',
  '^',
  '&',
  '*',
  '(',
  ')',
  '{',
  '}',
  '[',
  ']',
  '"',
  '“',
  '”',
  '_',
  '–',
  '¾',
];

export const WORDS_WITH_SPECIAL_REGEX = /([^\w\s])\1*|[\w][\w'`’‘-]*[\w]|'|\w+|\s+/gm;

export const NAV_LIST_MAP: Record<string, string> = {
  assessment: 'Assessment',
  exemplars: 'Exemplars',
  lessons: 'Lessons',
  planning: 'Planning',
  professional: 'Professional Learning',
  emergent: 'Emergent',
  early: 'Early',
  developing: 'Developing',
  consolidating: 'Consolidating',
  extending: 'Extending',
};

export const MAIN_NAV_LIST = [EXEMPLARS, PLANNING, LESSONS, ASSESSMENT, PROFESSIONAL];
export const EXEMPLARS_NAV_LIST = [EMERGENT, EARLY, DEVELOPING, CONSOLIDATING, EXTENDING];
export const PLANING_NAV_LIST = [
  'SCOPE AND SEQUENCE',
  'SUGGESTED TEACHING PATHWAYS',
  'TEXT TYPES',
  'ORAL AND VISUAL LITERACY',
  'WRITING SKILLS AND CONVENTIONS',
];
export const ASSESSMENT_NAV_LIST = [EMERGENT, EARLY, DEVELOPING, CONSOLIDATING, EXTENDING];
export const PROFESSIONAL_NAV_LIST = ['ABOUT PM WRITING', 'THE WRITING PROCESS', 'WRITING SKILLS AND CONVENTIONS'];

export const COLORS: Record<string, string> = {
  nouns: '#B2E2F8',
  adjectives: '#FEF2AB',
  'present-tense verbs': '#F9B7A7',
  'present tense verbs': '#F9B7A7',
  'past-tense verbs': '#F9B7A7',
  'past tense verbs': '#F9B7A7',
  'present tense relating verbs': '#F9B7A7',
  'present-tense relating verbs': '#F9B7A7',
  'time and sequence words': '#C5E2E2',
  'sensing verbs': '#F9B7A7',
  conjunctions: '#D8CDE5',
  'text connectives': '#D8CDE5',
  'conjunctions/text connectives': '#D8CDE5',
  'prepositional phrases': '#F2F2F2',
  phrases: '#F2F2F2',
  verbs: '#F9B7A7',
  // Language feature verbs
  lightGray: '#f6f6f6',
  extraLightGray: '#f9f9f9',
  mainTextColor: '#000',
  darkGray: '#565656',
  doveGray: '#666666',
  middleGray: '#8b8680',
  lavenderGray: '#c5cacf',
  slate: '#3b5063',
  whiteSmoke: '#F5F5F5',
  white: '#fff',
  black: '#000000',
  black50: 'rgba(0,0,0,0.5)',
  lightPink: '#FCE0EA',
  gainsboro: '#dcdcdc',
  gray95: '#f2f2f2',
  veryLightGrey: '#cccccc',
  lightSilver: '#d6d6d6',
  blueCola: '#027EE1',
  backgroundFocus: '#e4eff4',
  hover: '#EEEEEE',
  pronouns: '#DEFADE',
  adverbs: '#DBBD9B',
  prepositions: '#DEFADE',
  articles: '#DEFADE',
  darkSpringGreen: '#979797',
  yellowLight: '#FFF9D6',
  orangeLight: '#FDEBDA',
  redLight: '#FEE2E2',
  deepCarminePink: '#F63131',
  // Main exemplar colors
  mainGradientEmergent: 'linear-gradient(to right, #e5145b, #f05e93 49%, #f5a3c7)',
  mainGradientEarly: 'linear-gradient(to right, #6d2783, #7f3995 49%, #9e85be)',
  mainGradientDeveloping: 'linear-gradient(to right, #00808d, #2eb1be 49%, #5cc6d1)',
  mainGradientConsolidating: 'linear-gradient(to right, #0093c3, #007ea7, #7ad2f6 68%)',
  mainGradientExtending: 'linear-gradient(to right, #008746, #5cc259 49%, #c2d957)',
  mainGradient: 'linear-gradient(to right, #006298 0%, #d6e6ee 100%)',
  eminence: '#6d2783',
  platinum: '#e5d7ea',
  pinkLace: '#fce3ee',
  bondiBlue: '#0093c3',
  philippineGreen: '#008746',
  lightPurple: '#e1d0e6',
  backLink: '#202020',
  seaBlue: '#3942B0',
  ABG: '#E5145B',
  BBG: '#FCE3EE',
  A: '#FFFFFF',
  B: '#cd1252',
  blue: '#B7E9F7',
  wePeep: '#F9E8E9',
  blackOlive: '#3f3f3f',
  usafaBlue: '#0351A0',
  fuzzyWuzzy: '#d86c64',
  neutral3: '#727272',
  mercury: '#E6E6E6',
  cadmiumViolet: '#7f3995',
  americanViolet: '#671980',
  debianRed: '#cd1252',
  pinkRaspberry: '#a60039',
  metallicSeaweed: '#00808d',
  skobeloff: '#00626C',
  moreBackground: '#edf3f6',
  verbsButton: '#f3d969',
  verbsButtonActive: '#dfdfdf',
  darkBlue: '#005685',
  emergentTitle: '#1a80a3',
  veryLightPink: '#dfdfdf',
  emperor: '#545454',
  lightBlue: '#c9edfb',
  languidLavender: '#e1d0e6',
  classicRose: '#fbcedd',
  water: '#cfeef1',
  periwinkleGray: '#ced6e9',
  spindle: '#c2e5f0',
  lavender: '#e3ebfc',
  caper: '#E0ECAB',
  venetianRed: '#d90b10',
  formBlue: '#007ea7',
  gallery: '#F0F0F0',
  alto: '#d9d9d9',
  snuff: '#DCD4E7',
  teal: '#00727d',
  bahamaBlue: '#007095',
  funGreen: '#00753D',
  illusion: '#F5A3C7',
  brilliantRose: '#F05E93',
  lavenderPurple: '#9E85BE',
};

export const COLOR_PICKER = ['#b2e2f8', '#f9b7a7', '#fef2ab', '#d8cde5', '#e0ecab', '#dbbd9b'];

export const DRAWING_TOOL_COLORS = [COLORS.debianRed, COLORS.cadmiumViolet, '#00753d', COLORS.usafaBlue, '#000000'];
export const TEXT_TOOL_COLORS = [COLORS.debianRed, COLORS.cadmiumViolet, '#00753D', COLORS.usafaBlue, '#000000'];
export const TEXT_TOOL_COLORS_NAME = ['Debian Red', 'Cadmium Violet', 'Dartmouth Green', 'USAFA Blue', 'Black'];

export const SIZES: Record<string, string> = {
  XS: '88px',
  S: '188px',
  M: '250px',
  ML: '386px',
};

export const SECTIONS_COLORS: { [key: string]: SectionColor } = {
  teal: {
    title: '#3fbfb3',
    text: '#e2f2f2',
  },
  blue: {
    title: '#78a9d8',
    text: '#eaf4fc',
  },
  orange: {
    title: '#e8984f',
    text: '#fdf0df',
  },
  red: {
    title: '#f58d8d',
    text: '#fbe6e5',
  },
};

export const VERBS_FOCUS = `
text-transform: none;
margin: 0px;
:focus {
  z-index: 1;
  outline-offset: -1px !important;
  outline: 2px dotted ${COLORS.blueCola} !important;
}`;

export const FOCUS = `
:focus {
  outline-offset: 3px !important;
  outline: 2px dotted ${COLORS.blueCola} !important;
  background: ${COLORS.backgroundFocus} !important;
}`;

export const DOTTED_FOCUS = `
:focus {
  outline-offset: 3px;
  outline: 2px dotted ${COLORS.blueCola};
}`;

export const EXEMPLAR_FOCUS = `
:focus {
  outline-offset: 3px;
  outline: 2px dotted ${COLORS.blueCola};
  z-index: 10;
}`;

export const DANGER = `
color: #C61D23;
:focus {
  color: #7A151A !important;
}
:hover {
  color: #7A151A !important;
}`;

export const EXEMPLAR_STAGES: Record<string, string> = {
  early: 'Early',
  emergent: 'Emergent',
  developing: 'Developing',
  consolidating: 'Consolidating',
  extending: 'Extending',
};

export const BottomNavigationIds = {
  more: 1,
  teacherFocus: 2,
};
export const EXEMPLAR_MODES: Record<string, string> = {
  textPresentation: 'text-presentation',
  textStructure: 'text-structure',
  languageFeatures: 'language-features',
};

export const RELATED_ITEM_WIDTH = 989;
export const SHORT_RELATED_ITEM_WIDTH = 940;

export const MAIN_CONTENT_SIZE = {
  S: [926, 629],
  M: [926, 629],
  L: [926, 629],
};

export const HEADER_HEIGHT = 110;
export const COLORED_LINE_HEIGHT = 13;
export const NAVBAR_HEIGHT = 94;
export const BANNER_HEIGHT = 58;
export const FOOTER_HEIGHT = 50;

export const exemplarsMock = [
  {
    id: 1,
    title: 'Early A',
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/240px-No_image_available.svg.png',
    textTypes: [
      {
        id: 1,
        title: 'Recount',
      },
      {
        id: 2,
        title: 'Description',
      },
      {
        id: 3,
        title: 'Information report',
      },
      {
        id: 4,
        title: 'Narrative',
      },
    ],
    engagement: {
      id: 1,
      title: 'Engagement Prompts',
      image:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/240px-No_image_available.svg.png',
    },
  },
  {
    id: 2,
    title: 'Early B',
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/240px-No_image_available.svg.png',
    textTypes: [
      {
        id: 1,
        title: 'Recount',
      },
      {
        id: 2,
        title: 'Description',
      },
      {
        id: 3,
        title: 'Information report',
      },
      {
        id: 4,
        title: 'Narrative',
      },
      {
        id: 5,
        title: 'Narrative',
      },
    ],
    engagement: {
      id: 1,
      title: 'Engagement Prompts',
      image:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/240px-No_image_available.svg.png',
    },
  },
  {
    id: 2,
    title: 'Early C',
    image:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/240px-No_image_available.svg.png',
    textTypes: [
      {
        id: 1,
        title: 'Recount',
      },
      {
        id: 2,
        title: 'Description',
      },
      {
        id: 3,
        title: 'Information report',
      },
      {
        id: 4,
        title: 'Narrative',
      },
      {
        id: 5,
        title: 'Narrative',
      },
    ],
    engagement: {
      id: 1,
      title: 'Engagement Prompts',
      image:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/240px-No_image_available.svg.png',
    },
  },
];

export const STYLES: Record<string, string> = {
  bold: 'font-weight: 800;',
  italic: 'font-style: italic;',
  shadow: 'box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.65);',
  borderRadius: 'border-radius: 4px;',
  bg: 'background-color: white !important;',
  highlighted: 'background: white;',
  nospacing: 'padding: 0 !important;',
};

export const exemplar = {
  meta: { isIntroducedToHybrid: undefined },
  is_default: true,
  title: 'Show Animals',
  guid: 'be3abd44-0c42-44cc-9c9b-834104d4840c',
  stage: 'Early',
  text_type: 'Information Report',
  collection: 'Early A',
  relationships: {
    images: [
      {
        uuid: '4321',
        url: './4321.jpb',
      },
      {
        uuid: '1234',
        url: './1234.jpb',
      },
    ],
  },
  teacher_focus: [
    {
      screen: 'Text Presentation',
      content: '__Purpose:__ To present information that classifies living or non-living things',
    },
    {
      screen: 'Text Structure',
      content:
        'Focus students’ attention on the text structure by asking the following questions:\n\n__Title:__ [question/s to come]\n\n__General Statement:__ [question/s to come] \n\n__Description:__ [question/s to come] \n\n__Evaluation:__ [question/s to come]',
    },
    {
      screen: 'Language Features',
      content:
        'Focus students’ attention on the specific language features of the text:\n\n- [to come]\n\n- [to come]\n\n- [to come]',
    },
  ],
  section_labels: [
    {
      label: 'Title',
      color: 'teal',
      description: '',
    },
    {
      label: 'General Statement',
      color: 'orange',
      description: 'What are the living or non-living things?',
    },
    {
      label: 'Description',
      color: 'blue',
      description: 'What do they look like? What can they do?',
    },
    {
      label: 'Evaluation',
      color: 'red',
      description: 'How does the writer feel about the topic?',
    },
  ],
  language_feature_labels: [
    {
      label: 'Nouns',
      color: 'blue',
    },
    {
      label: 'Adjectives',
      color: 'yellow',
    },
    {
      label: 'Present-tense verbs',
      color: 'red',
    },
  ],
  content: {
    left: [
      {
        type: 'section',
        color: '24408E',
        lines: [
          {
            words: [
              {
                text: 'Bluehill',
              },
              {
                text: 'Primary',
              },
              {
                text: 'School',
              },
              {
                text: 'Newsletter',
              },
            ],
          },
          {
            words: [
              {
                text: 'Wednesday',
              },
              {
                text: '6',
              },
              {
                text: 'August',
              },
            ],
          },
        ],
        style: ['right-aligned'],
        id: 'tqotynYlrhPhc7XC',
      },
      {
        type: 'section',
        label: 'Title',
        style: ['heading'],
        id: '0',
        lines: [
          {
            words: [
              {
                text: 'Show',
              },
              {
                text: 'Animals',
              },
            ],
          },
        ],
      },
      {
        type: 'section',
        label: 'General Statement',
        id: '1',
        lines: [
          {
            words: [
              {
                text: 'Show',
                language: 'Nouns',
                style: ['bold', 'italic'],
              },
              {
                text: 'animals',
                language: 'Nouns',
                prepositional_phrase: true,
              },
              {
                text: 'are',
                language: 'Present-tense verbs',
              },
              {
                text: 'animals',
                language: 'Nouns',
              },
            ],
          },
          {
            words: [
              {
                text: 'that',
                prepositional_phrase: true,
              },
              {
                text: 'can',
                language: 'Present-tense verbs',
                prepositional_phrase: true,
              },
              {
                text: 'win',
                language: 'Present-tense verbs',
              },
              {
                text: 'prizes',
                language: 'Nouns',
              },
              {
                text: 'at',
              },
              {
                text: 'shows',
                language: 'Nouns',
                style: ['bold'],
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
          {
            words: [
              {
                text: 'It',
              },
              {
                text: 'is',
              },
              {
                text: 'another',
              },
              {
                text: 'line',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
        ],
      },
      {
        type: 'section',
        label: 'Description',
        id: '2',
        lines: [
          {
            words: [
              {
                text: 'There',
              },
              {
                text: 'are',
                language: 'Present-tense verbs',
              },
              {
                text: 'lots',
                text_type: 'Description',
                phrase: true,
              },
              {
                text: 'of',
                phrase: true,
                style: ['separate-next-phrase'],
              },
              {
                text: 'animals',
                language: 'Nouns',
                phrase: true,
              },
              {
                text: 'to',
              },
              {
                text: 'see',
                language: 'Present-tense verbs',
              },
              {
                text: 'again',
              },
              {
                text: 'and',
              },
              {
                text: 'again',
              },
            ],
          },
          {
            words: [
              {
                text: 'at',
              },
              {
                text: 'shows',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
          {
            words: [],
          },
          {
            words: [
              {
                text: 'Cows',
                language: 'Nouns',
              },
              {
                text: 'and',
              },
              {
                text: 'bulls',
                language: 'Nouns',
              },
              {
                text: 'are',
                language: 'Present-tense verbs',
              },
              {
                text: 'show',
                language: 'Nouns',
                style: ['separate-next'],
              },
              {
                text: 'animals',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
          {
            words: [
              {
                text: 'They',
              },
              {
                text: 'walk',
                language: 'Present-tense verbs',
              },
              {
                text: 'in',
              },
              {
                text: 'a',
              },
              {
                text: 'long',
                language: 'Adjectives',
              },
              {
                text: 'line',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
          {
            words: [
              {
                text: 'There',
              },
              {
                text: 'are',
                language: 'Present-tense verbs',
              },
              {
                text: 'prizes',
                language: 'Nouns',
              },
            ],
          },
          {
            words: [
              {
                text: 'for',
              },
              {
                text: 'the',
              },
              {
                text: 'best',
                language: 'Adjectives',
              },
              {
                text: 'cows',
                language: 'Nouns',
              },
              {
                text: 'and',
              },
              {
                text: 'bulls',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
        ],
      },
      {
        id: 'ONbmwM8mVlHMo3Xw',
        editable: true,
        type: 'image',
        url: '1234/FgKnE5orx5.jpg',
        uuid: '1234',
      },
    ],
    right: [
      {
        type: 'section',
        label: 'Description',
        id: '0',
        lines: [
          {
            words: [
              {
                text: 'Some',
              },
              {
                text: 'horses',
                language: 'Nouns',
              },
              {
                text: 'and',
              },
              {
                text: 'their',
              },
              {
                text: 'riders',
                language: 'Nouns',
              },
            ],
          },
          {
            words: [
              {
                text: 'do',
                language: 'Present-tense verbs',
              },
              {
                text: 'show',
                language: 'Nouns',
              },
              {
                text: 'jumping',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
          {
            words: [
              {
                text: 'The',
              },
              {
                text: 'horses',
                language: 'Nouns',
              },
              {
                text: 'jump',
                language: 'Present-tense verbs',
              },
              {
                text: 'over',
              },
              {
                text: 'big',
                language: 'Adjectives',
              },
              {
                text: 'fences',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
          {
            words: [
              {
                text: 'The',
              },
              {
                text: 'best',
                language: 'Adjectives',
              },
              {
                text: 'horse',
                language: 'Nouns',
              },
              {
                text: 'and',
              },
              {
                text: 'rider',
                language: 'Nouns',
              },
            ],
          },
          {
            words: [
              {
                text: 'win',
                language: 'Present-tense verbs',
              },
              {
                text: 'a',
              },
              {
                text: 'ribbon',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
          {
            words: [],
          },
          {
            words: [
              {
                text: 'Dogs',
                language: 'Nouns',
              },
              {
                text: 'are',
                language: 'Present-tense verbs',
              },
              {
                text: 'show',
                language: 'Nouns',
              },
              {
                text: 'animals',
                language: 'Nouns',
              },
              {
                text: ',',
                style: ['nospacing'],
              },
              {
                text: 'too',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
          {
            words: [
              {
                text: 'Big',
                language: 'Adjectives',
              },
              {
                text: 'dogs',
                language: 'Nouns',
              },
              {
                text: 'and',
              },
              {
                text: 'little',
                language: 'Adjectives',
              },
              {
                text: 'dogs',
                language: 'Nouns',
              },
            ],
          },
          {
            words: [
              {
                text: 'win',
                language: 'Present-tense verbs',
              },
              {
                text: 'prizes',
                language: 'Nouns',
              },
              {
                text: 'at',
              },
              {
                text: 'shows',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
        ],
      },
      {
        type: 'section',
        label: 'Evaluation',
        id: '1',
        lines: [
          {
            words: [
              {
                text: 'Shows',
                language: 'Nouns',
              },
              {
                text: 'are',
                language: 'Present-tense verbs',
              },
              {
                text: 'good',
                language: 'Adjectives',
              },
              {
                text: 'places',
                language: 'Nouns',
              },
              {
                text: 'to',
              },
              {
                text: 'see',
                language: 'Present-tense verbs',
              },
            ],
          },
          {
            words: [
              {
                text: 'lots',
              },
              {
                text: 'of',
              },
              {
                text: 'animals',
                language: 'Nouns',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
        ],
      },
      {
        id: 'WuBqkWQkdazblPqq',
        editable: true,
        type: 'image',
        url: '1235/0BjXas8fBo.jpg',
        uuid: '4321',
      },
    ],
  },
};

export const exemplarWithBottomImage = {
  ...exemplar,
  content: {
    left: [
      {
        type: 'section',
        lines: [
          {
            words: [
              {
                text: 'string',
              },
            ],
          },
        ],
      },
    ],
    right: [
      {
        type: 'section',
        lines: [
          {
            words: [
              {
                text: 'string',
              },
            ],
          },
        ],
      },
    ],
    bottom: [
      {
        url: 'extendingimages/extending-a-the-mermaid-of-my-youth-02.jpg',
        type: 'image',
        uuid: 'a4f957bc-a8d7-4db3-8914-908c82119a5c',
        editable: true,
      },
    ],
  },
  relationships: {
    images: [
      {
        uuid: 'a4f957bc-a8d7-4db3-8914-908c82119a5c',
        url: 'https://slisarenko-pmwri-media-dev.s3.eu-central-1.amazonaws.com/tests/308/extending-a-the-mermaid-of-my-youth-02.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAUSYSHQMCZP26I5OF%2F20230302%2Feu-central-1%2Fs3%2Faws4_request&X-Amz-Date=20230302T112143Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=14817b2b1e28df4e1c5d0a3d535239a39c75b25a04b1a6eafc4c8fa1ceeeed1e',
      },
    ],
  },
};

export const procedureExemplarWithImages = {
  ...exemplar,
  text_type: 'Procedure',
  content: {
    left: [
      {
        type: 'section',
        label: 'Title',
        lines: [{ words: [{ text: 'string' }] }],
      },
      {
        url: 'earlyimages/early-a-make-a-bear-spoon-family-01.jpg',
        type: 'image',
        uuid: 'baaf1fe9-638f-469e-9de4-ee6755a544e7',
        editable: true,
        position: {
          x: 1,
          y: 1,
          width: 10,
          height: 10,
        },
      },
    ],
    right: [
      {
        url: 'earlyimages/early-a-make-a-bear-spoon-family-02.jpg',
        type: 'image',
        uuid: '878e9693-52b9-4757-8ce1-78064c82eedf',
        editable: true,
        position: {
          x: 1,
          y: 1,
          width: 10,
          height: 10,
        },
      },
      {
        url: 'earlyimages/early-a-make-a-bear-spoon-family-03.jpg',
        type: 'image',
        uuid: '7fd136de-0e6b-490f-91af-9a0fb5e6c211',
        editable: true,
        position: {
          x: 1,
          y: 1,
          width: 10,
          height: 10,
        },
      },
    ],
  },
  relationships: {
    images: [
      {
        uuid: '5e5ffa44-3b36-4ce5-ac1a-0bc5f8204373',
        url: 'https://pmwri-media-dev.s3.eu-central-1.amazonaws.com/1',
      },
      {
        uuid: 'baaf1fe9-638f-469e-9de4-ee6755a544e7',
        url: 'https://pmwri-media-dev.s3.eu-central-1.amazonaws.com/2',
      },
      {
        uuid: '878e9693-52b9-4757-8ce1-78064c82eedf',
        url: 'https://pmwri-media-dev.s3.eu-central-1.amazonaws.com/3',
      },
      {
        uuid: '7fd136de-0e6b-490f-91af-9a0fb5e6c211',
        url: 'https://pmwri-media-dev.s3.eu-central-1.amazonaws.com/4',
      },
    ],
  },
};

export const procedureExemplar = {
  stage: 'Developing',
  title: 'Procedure',
  text_type: 'Procedure',
  collection: 'Developing A',
  content: {
    left: [
      {
        type: 'section',
        label: 'Title',
        lines: [
          {
            words: [
              {
                text: 'Procedure',
              },
            ],
          },
        ],
        style: ['heading'],
      },
      {
        type: 'section',
        label: 'Materials',
        lines: [
          {
            style: ['sub-heading'],
            words: [
              {
                text: 'Materials',
              },
            ],
          },
          {
            style: ['unordered-list'],
            words: [
              {
                text: 'three',
              },
              {
                text: 'spoons',
              },
            ],
          },
        ],
      },
      {
        type: 'section',
        label: 'Steps',
        lines: [
          {
            style: ['sub-heading'],
            words: [
              {
                text: 'Steps',
              },
            ],
          },
          {
            style: ['ordered-list'],
            words: [
              {
                text: 'Paint',
              },
              {
                text: '\n\n',
              },
              {
                text: 'with',
              },
              {
                text: 'brown',
              },
            ],
            sequence_number: '1.',
          },
        ],
      },
    ],
    right: [
      {
        type: 'section',
        label: 'Steps',
        lines: [
          {
            style: ['ordered-list'],
            words: [
              {
                text: 'Draw',
              },
              {
                text: 'ears',
              },
            ],
            sequence_number: '2.',
          },
        ],
      },
    ],
  },
};

export const MoreCollection: IAsset[] = [
  {
    type: 'Video',
    title: '',
    description: '',
    thumbnail: '',
    stages: ['Early'],
    links: {
      self: 'self/1',
    },
  },
  {
    type: 'PDF',
    title: '',
    description: '',
    thumbnail: '',
    stages: ['Early'],
    links: {
      self: 'self/2',
    },
  },
];

export const MoreCollectionEarly = (query: string): IAsset => {
  return {
    type: 'IWP',
    title: 'Interactive Writing Proforma',
    description: '',
    thumbnail: '',
    stages: ['Early'],
    links: {
      self: `/default/interactive-writing-proforma?${query}`,
    },
  };
};

export const emergentExemplar = {
  stage: 'Emergent',
  title: 'Beaches',
  content: [
    {
      type: 'screen',
      label: 'Words',
      words: [
        {
          text: 'sand',
          position: {
            x: 10,
            y: 50,
          },
          id: 'G4TnH9XddskWR7Ch',
        },
        {
          text: 'water',
          position: {
            x: 32,
            y: 35,
          },
          id: 'utlrsdj1EJ3rYLcJ',
        },
        {
          text: 'rocks',
          position: {
            x: 35,
            y: 84,
          },
          id: 'm9liF70tuJh4q658',
        },
        {
          text: 'sandcastle',
          position: {
            x: 67,
            y: 33,
          },
          id: 'krZNEyOY9QWWWYVD',
        },
        {
          text: 'seagulls',
          position: {
            x: 65,
            y: 73,
          },
          id: 'TMMP8kmgqwnHxtZC',
        },
        {
          text: 'have',
          id: '7Ew1ZlrXj57ZZWgI',
        },
        {
          text: 'fly',
          id: 'PZylxFpHtdaro5sN',
        },
        {
          text: 'swim',
          id: '8meKXPV7ctAKi1Qa',
        },
        {
          text: 'is',
          id: 'Wlkxn6RdYjXooU4o',
        },
      ],
      images: [
        {
          editable: true,
          url: 'emergentimages/3201_pmw_em_a_57804.jpg',
          uuid: '96ce9fac-3044-41a8-947b-09706bb2215e',
          position: {
            x: 5,
            y: 20,
            width: 40,
            height: 40,
          },
          id: 'wJsHJCMPxTgBRfg2',
        },
        {
          url: 'emergentimages/3202_pmw_em_a_57804.jpg',
          uuid: '954678b0-79a3-4431-a3d6-8efa8d8595f0',
          position: {
            x: 15,
            y: 65,
            width: 30,
            height: 25,
          },
          id: 'x2Wpos44tQf5u7iw',
        },
        {
          url: 'emergentimages/3301_pmw_em_a_57804.jpg',
          uuid: '0f603aec-ca5a-428e-873e-adcee6f6b9d5',
          position: {
            x: 70,
            y: 20,
            width: 25,
            height: 25,
          },
          id: 'NaO1wayLNAm5b3Pq',
        },
        {
          url: 'emergentimages/3302_pmw_em_a_57804.jpg',
          uuid: '85887e3d-e13d-4b0c-8fa3-5b6c94a7ebcc',
          position: {
            x: 55,
            y: 50,
            width: 30,
            height: 25,
          },
          id: 'd2qetqkoJeE7LHRi',
        },
      ],
      label_color: 'F3D669',
    },
    {
      type: 'screen',
      label: 'Sentences',
      content: {
        left: [
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Beaches',
                    id: 'HMCTLGxLmHAjxlkL',
                    lineId: 'JAS4QCYMItX9RQCH',
                    sectionId: 'jCGrLBGm3oxOTxkQ',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'JAS4QCYMItX9RQCH',
              },
            ],
            style: ['heading'],
            id: 'jCGrLBGm3oxOTxkQ',
          },
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Beaches',
                    id: 'ikYLz7vQchsuVK2n',
                    lineId: 'CN8kaI8PJoZdfgmj',
                    sectionId: 'yY0TCJ57KVUxXR2f',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'have',
                    id: 'ncfeCQoJqkDonpxs',
                    lineId: 'CN8kaI8PJoZdfgmj',
                    sectionId: 'yY0TCJ57KVUxXR2f',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'lots',
                    id: 'gtpTCwJ6IxcE2YCg',
                    lineId: 'CN8kaI8PJoZdfgmj',
                    sectionId: 'yY0TCJ57KVUxXR2f',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'of',
                    id: 'VGzhovdVZ1LBRUbL',
                    lineId: 'CN8kaI8PJoZdfgmj',
                    sectionId: 'yY0TCJ57KVUxXR2f',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'sand',
                    id: 'sMuOm74hPdgYJa7l',
                    lineId: 'CN8kaI8PJoZdfgmj',
                    sectionId: 'yY0TCJ57KVUxXR2f',
                    wordIndex: '4',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'CN8kaI8PJoZdfgmj',
              },
              {
                words: [
                  {
                    text: 'and',
                    id: '2od3PTsFoiDJ1FgV',
                    lineId: '5S3IrlAAiQ9EIlyZ',
                    sectionId: 'yY0TCJ57KVUxXR2f',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'water',
                    id: 'jUIwFMA5PY5xadI4',
                    lineId: '5S3IrlAAiQ9EIlyZ',
                    sectionId: 'yY0TCJ57KVUxXR2f',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'oqEKA3ibqcghhORs',
                    lineId: '5S3IrlAAiQ9EIlyZ',
                    sectionId: 'yY0TCJ57KVUxXR2f',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: '5S3IrlAAiQ9EIlyZ',
              },
            ],
            id: 'yY0TCJ57KVUxXR2f',
          },
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Some',
                    id: 'ANbcZadsC16Mjjbj',
                    lineId: 'IeAbhZA9cRG5chz0',
                    sectionId: '9TbKayvosKCbOc6X',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'beaches',
                    id: '7Ic1C7ySFTYGF7yH',
                    lineId: 'IeAbhZA9cRG5chz0',
                    sectionId: '9TbKayvosKCbOc6X',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'have',
                    id: 'EEuPoIyrD3AdqqvF',
                    lineId: 'IeAbhZA9cRG5chz0',
                    sectionId: '9TbKayvosKCbOc6X',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'rocks',
                    id: 'yQqcQoDpjdhanQa2',
                    lineId: 'IeAbhZA9cRG5chz0',
                    sectionId: '9TbKayvosKCbOc6X',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'fY0XAX6MC0bJYXbJ',
                    lineId: 'IeAbhZA9cRG5chz0',
                    sectionId: '9TbKayvosKCbOc6X',
                    wordIndex: '4',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'IeAbhZA9cRG5chz0',
              },
            ],
            id: '9TbKayvosKCbOc6X',
          },
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Seagulls',
                    id: 'iu9QmIYfLIG4rzJu',
                    lineId: 'yTALIrXm1w9TtDOx',
                    sectionId: 'tFB4HVv6NwSviybN',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '3',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'fly',
                    id: 'QcB1dIsRxwVHkswH',
                    lineId: 'yTALIrXm1w9TtDOx',
                    sectionId: 'tFB4HVv6NwSviybN',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '3',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'up',
                    id: 'Jw8pngnaNiFWjVDN',
                    lineId: 'yTALIrXm1w9TtDOx',
                    sectionId: 'tFB4HVv6NwSviybN',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '3',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'and',
                    id: 'zhK4yMmBgVGIGGT7',
                    lineId: 'yTALIrXm1w9TtDOx',
                    sectionId: 'tFB4HVv6NwSviybN',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '3',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'down',
                    id: 'g9Y7h4wavA5gc3Hx',
                    lineId: 'yTALIrXm1w9TtDOx',
                    sectionId: 'tFB4HVv6NwSviybN',
                    wordIndex: '4',
                    lineIndex: '0',
                    sectionIndex: '3',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'yTALIrXm1w9TtDOx',
              },
              {
                words: [
                  {
                    text: 'some',
                    id: 'qfk1oF3SdXBr6tVx',
                    lineId: 'pcdwqysHujaoji8g',
                    sectionId: 'tFB4HVv6NwSviybN',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '3',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'beaches',
                    id: 'zilQSQbaa1fOwZaF',
                    lineId: 'pcdwqysHujaoji8g',
                    sectionId: 'tFB4HVv6NwSviybN',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '3',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'TJFTt4KTxc4ku9uJ',
                    lineId: 'pcdwqysHujaoji8g',
                    sectionId: 'tFB4HVv6NwSviybN',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '3',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'pcdwqysHujaoji8g',
              },
            ],
            id: 'tFB4HVv6NwSviybN',
          },
          {
            editable: true,
            url: 'emergentimages/3302_pmw_em_a_57804.jpg',
            type: 'image',
            uuid: 'ac0453e4-a521-4d83-9d9b-d4b44694be2f',
            id: '0LPPQi2TDJDpNj7c',
          },
        ],
        right: [
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Children',
                    id: 'pRBVaPolRXAXgwPK',
                    lineId: 'DDExjrD9wY5tUBo9',
                    sectionId: 'w1VMAtP5xPrZHf00',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'like',
                    id: 'kHsasDMpLP3SZHXt',
                    lineId: 'DDExjrD9wY5tUBo9',
                    sectionId: 'w1VMAtP5xPrZHf00',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'to',
                    id: 'yvCyRUeP6DrzjcG5',
                    lineId: 'DDExjrD9wY5tUBo9',
                    sectionId: 'w1VMAtP5xPrZHf00',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'swim',
                    id: 'xjRAItukNu82WBJB',
                    lineId: 'DDExjrD9wY5tUBo9',
                    sectionId: 'w1VMAtP5xPrZHf00',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'DDExjrD9wY5tUBo9',
              },
              {
                words: [
                  {
                    text: 'in',
                    id: '7548S8erOc4uRvfa',
                    lineId: 'DVGbK6W5EMN0TXiA',
                    sectionId: 'w1VMAtP5xPrZHf00',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'the',
                    id: 'xibza6Ddog1J3AS8',
                    lineId: 'DVGbK6W5EMN0TXiA',
                    sectionId: 'w1VMAtP5xPrZHf00',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'water',
                    id: '8JBwNNM5O9K5Sdui',
                    lineId: 'DVGbK6W5EMN0TXiA',
                    sectionId: 'w1VMAtP5xPrZHf00',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'tI2txb9K4Mu849PS',
                    lineId: 'DVGbK6W5EMN0TXiA',
                    sectionId: 'w1VMAtP5xPrZHf00',
                    wordIndex: '3',
                    lineIndex: '1',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'DVGbK6W5EMN0TXiA',
              },
            ],
            id: 'w1VMAtP5xPrZHf00',
          },
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'It',
                    id: 'ORXOsnJ9pwHM95tB',
                    lineId: 'lMKtemb5H6u3y80X',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'is',
                    id: 'v96N3G96lu1i7pD3',
                    lineId: 'lMKtemb5H6u3y80X',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'good',
                    id: 'mAOYmT46A26JLpRT',
                    lineId: 'lMKtemb5H6u3y80X',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'to',
                    id: 'XeByvTlwtHN3pqEt',
                    lineId: 'lMKtemb5H6u3y80X',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'go',
                    id: '1aBSTFU7mYFeuir0',
                    lineId: 'lMKtemb5H6u3y80X',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '4',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'lMKtemb5H6u3y80X',
              },
              {
                words: [
                  {
                    text: 'to',
                    id: '0t8fVkHPe6rV1f3C',
                    lineId: 'luxwe9ynvrIopl6N',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'the',
                    id: 'X1Fao2AoSTbwqSr9',
                    lineId: 'luxwe9ynvrIopl6N',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: 'beach',
                    id: 'yYp6Vfd1JvVd5g0G',
                    lineId: 'luxwe9ynvrIopl6N',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'mwc5jkES1C6WuZQk',
                    lineId: 'luxwe9ynvrIopl6N',
                    sectionId: 'Ps1YNSjnzilKxcBg',
                    wordIndex: '3',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Sentences',
                  },
                ],
                id: 'luxwe9ynvrIopl6N',
              },
            ],
            id: 'Ps1YNSjnzilKxcBg',
          },
          {
            editable: true,
            url: 'emergentimages/3201_pmw_em_a_57804.jpg',
            type: 'image',
            uuid: '3c330fe3-0c84-46ef-ba8b-3257d5a20f92',
            id: '06Z5yuKCmePh8adk',
          },
        ],
      },
    },
    {
      type: 'screen',
      label: 'Words and Sentences',
      content: {
        left: [
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Beaches',
                    id: 'Cetxi2eTf83PcxVb',
                    lineId: 'q3E4DwozP7D7RQln',
                    sectionId: '31g8Qs0tKMwA635G',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'q3E4DwozP7D7RQln',
              },
            ],
            style: ['heading'],
            id: '31g8Qs0tKMwA635G',
          },
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Beaches',
                    id: '45lVcr4RvSULDI5f',
                    lineId: 'YNoFEHecFqcMU5Gw',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'have',
                    id: 'Q2IA6GNLbOvgzYwN',
                    lineId: 'YNoFEHecFqcMU5Gw',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'lots',
                    id: 'kvFOTTGNiCNIWuj0',
                    lineId: 'YNoFEHecFqcMU5Gw',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'of',
                    id: 'eM0oyKB98p2ScGwI',
                    lineId: 'YNoFEHecFqcMU5Gw',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'sand',
                    id: 'I20ybzGrKB9hu5A3',
                    lineId: 'YNoFEHecFqcMU5Gw',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '4',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'YNoFEHecFqcMU5Gw',
              },
              {
                words: [
                  {
                    text: 'and',
                    id: 'K2MBLMnHa30rHhhi',
                    lineId: 'OQBhtkSxoz9X6QZd',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'water',
                    id: '0OVyemEaW501FAkJ',
                    lineId: 'OQBhtkSxoz9X6QZd',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'bQhS4GyYHv91CWZk',
                    lineId: 'OQBhtkSxoz9X6QZd',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'OQBhtkSxoz9X6QZd',
              },
              {
                words: [
                  {
                    text: 'There',
                    style: ['highlighted'],
                    id: 'vkF8BRGlMkWUKMqe',
                    lineId: 'PTQPsI1v9GftbgMv',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '0',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'are',
                    style: ['highlighted'],
                    id: 'mqe6ya4Ubsq5mAvO',
                    lineId: 'PTQPsI1v9GftbgMv',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '1',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'shells',
                    style: ['highlighted'],
                    id: 'GfeXGETuBADZEW4k',
                    lineId: 'PTQPsI1v9GftbgMv',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '2',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: ',',
                    style: ['highlighted', 'nospacing'],
                    id: 'D4TAkhi0x5RMPT29',
                    lineId: 'PTQPsI1v9GftbgMv',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '3',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'too',
                    style: ['highlighted'],
                    id: '7VjsaMHYNpn9pZeb',
                    lineId: 'PTQPsI1v9GftbgMv',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '4',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['highlighted', 'nospacing'],
                    id: '5pFf3C1X92ljxOZz',
                    lineId: 'PTQPsI1v9GftbgMv',
                    sectionId: 'S60BHMTvMMQkbd2C',
                    wordIndex: '5',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'PTQPsI1v9GftbgMv',
              },
            ],
            id: 'S60BHMTvMMQkbd2C',
          },
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Some',
                    id: 'VfuKnQlXG2MsfF94',
                    lineId: 'DpNQIQ9bqR8p2dpW',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'beaches',
                    id: 'KsK9qI0AqfWhLDlg',
                    lineId: 'DpNQIQ9bqR8p2dpW',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'have',
                    id: 'GtVMr8Vro4VxoKc0',
                    lineId: 'DpNQIQ9bqR8p2dpW',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'rocks',
                    id: 'dK4tBdgBF8bbcesr',
                    lineId: 'DpNQIQ9bqR8p2dpW',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'RqfYu2QnjQjF8SXy',
                    lineId: 'DpNQIQ9bqR8p2dpW',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '4',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'DpNQIQ9bqR8p2dpW',
              },
              {
                words: [
                  {
                    text: 'Little',
                    style: ['highlighted'],
                    id: '08AdqHBs3xYV7HlD',
                    lineId: 'L7M5WmbUlPV87vcg',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'crabs',
                    style: ['highlighted'],
                    id: 'O2wFL88aATYFgy8E',
                    lineId: 'L7M5WmbUlPV87vcg',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'live',
                    style: ['highlighted'],
                    id: 'LjaHPCqEgRQKRG7p',
                    lineId: 'L7M5WmbUlPV87vcg',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'on',
                    style: ['highlighted'],
                    id: 'OZKf3SwTHDzAb71h',
                    lineId: 'L7M5WmbUlPV87vcg',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '3',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'the',
                    style: ['highlighted'],
                    id: 'PtUQW9ewu6E2lVkO',
                    lineId: 'L7M5WmbUlPV87vcg',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '4',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'rocks',
                    style: ['highlighted'],
                    id: 'L68qvcjAYi8Y9oW2',
                    lineId: 'L7M5WmbUlPV87vcg',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '5',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing', 'highlighted'],
                    id: 'yXBIsUkpgY7vuQqy',
                    lineId: 'L7M5WmbUlPV87vcg',
                    sectionId: 'f9OSSLFoJSAFDlkt',
                    wordIndex: '6',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'left',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'L7M5WmbUlPV87vcg',
              },
            ],
            id: 'f9OSSLFoJSAFDlkt',
          },
          {
            url: 'emergentimages/3601_pmw_em_a_57804.jpg',
            type: 'image',
            uuid: '60a0c63a-32f7-4d75-b904-e9d7d5a0a39a',
            id: 'abZkJW5Hjl0tcX83',
          },
        ],
        right: [
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Seagulls',
                    id: 'At2gQ1RqK9cELIam',
                    lineId: 'zMqL5Xo8knKgH0r2',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'fly',
                    id: 'ABxMA9FeZe5A3pFl',
                    lineId: 'zMqL5Xo8knKgH0r2',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'up',
                    id: 'w0yzdI8f7upsMaV9',
                    lineId: 'zMqL5Xo8knKgH0r2',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'and',
                    id: 'cwSqr5Uwe6nJmos0',
                    lineId: 'zMqL5Xo8knKgH0r2',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'down',
                    id: 'FNsIuLP5WPgr0fNh',
                    lineId: 'zMqL5Xo8knKgH0r2',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '4',
                    lineIndex: '0',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'zMqL5Xo8knKgH0r2',
              },
              {
                words: [
                  {
                    text: 'some',
                    id: 'hijNcE5RngQsuhok',
                    lineId: 'B7psonWMmmqufm28',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'beaches',
                    id: 'B2Ibkyz4xBNlBZs9',
                    lineId: 'B7psonWMmmqufm28',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'jMDrb6IKkKiWJu8f',
                    lineId: 'B7psonWMmmqufm28',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'B7psonWMmmqufm28',
              },
              {
                words: [
                  {
                    text: 'The',
                    style: ['highlighted'],
                    id: 'LdvBBLPcTST5pwRm',
                    lineId: 'xnTGosgd6ySTJ1OA',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '0',
                    lineIndex: '2',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'seagulls',
                    style: ['highlighted'],
                    id: 'EvGh8gBAdhMJBjwN',
                    lineId: 'xnTGosgd6ySTJ1OA',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '1',
                    lineIndex: '2',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'look',
                    style: ['highlighted'],
                    id: 'G19o40a1eU6DP5cP',
                    lineId: 'xnTGosgd6ySTJ1OA',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '2',
                    lineIndex: '2',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'for',
                    style: ['highlighted'],
                    id: 'tjKoKcRe7yBNMvvq',
                    lineId: 'xnTGosgd6ySTJ1OA',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '3',
                    lineIndex: '2',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'food',
                    style: ['highlighted'],
                    id: 'sPH3ksNrft3EaXV6',
                    lineId: 'xnTGosgd6ySTJ1OA',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '4',
                    lineIndex: '2',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['highlighted', 'nospacing'],
                    id: 'h1cH1VtoneRdXqBs',
                    lineId: 'xnTGosgd6ySTJ1OA',
                    sectionId: 'OL4yu4UTq2INRbFD',
                    wordIndex: '5',
                    lineIndex: '2',
                    sectionIndex: '0',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'xnTGosgd6ySTJ1OA',
              },
            ],
            id: 'OL4yu4UTq2INRbFD',
          },
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'Children',
                    id: 'bIzDGaJVG6Im4Pr9',
                    lineId: 'viAf4JRf6jsxLOnE',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'like',
                    id: '08Xe15kHT7gH9jvF',
                    lineId: 'viAf4JRf6jsxLOnE',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'to',
                    id: 'YWtbZ7xR2hfIllhA',
                    lineId: 'viAf4JRf6jsxLOnE',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'swim',
                    id: 'B6Jv3rsBOdWXvNA5',
                    lineId: 'viAf4JRf6jsxLOnE',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'viAf4JRf6jsxLOnE',
              },
              {
                words: [
                  {
                    text: 'in',
                    id: 'huIkKfaf7yPSHYxI',
                    lineId: 'irBCaYhENCWULjCT',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'the',
                    id: '83yyit80T3RFLV11',
                    lineId: 'irBCaYhENCWULjCT',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'water',
                    id: '5rSnmJv830RoTypT',
                    lineId: 'irBCaYhENCWULjCT',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'G7SyrXE7UucWDXY9',
                    lineId: 'irBCaYhENCWULjCT',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '3',
                    lineIndex: '1',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'irBCaYhENCWULjCT',
              },
              {
                words: [
                  {
                    text: 'They',
                    style: ['highlighted'],
                    id: 'YUNbmvtkI0N3jQRU',
                    lineId: 'T0EdebjeF1BV8tJo',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '0',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'like',
                    style: ['highlighted'],
                    id: 'UaIEF9JHDvShyY44',
                    lineId: 'T0EdebjeF1BV8tJo',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '1',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'to',
                    style: ['highlighted'],
                    id: 'McXGyQoIYublcgZ0',
                    lineId: 'T0EdebjeF1BV8tJo',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '2',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'make',
                    style: ['highlighted'],
                    id: 'BliSshI6HFlEy68p',
                    lineId: 'T0EdebjeF1BV8tJo',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '3',
                    lineIndex: '2',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'T0EdebjeF1BV8tJo',
              },
              {
                words: [
                  {
                    text: 'sandcastles',
                    style: ['highlighted'],
                    id: '9AoPzFCQFSPRDPQ2',
                    lineId: 'gOLte2dwEFsHQLOw',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '0',
                    lineIndex: '3',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: ',',
                    style: ['highlighted', 'nospacing'],
                    id: 'H9hxeYXfBkqgepTU',
                    lineId: 'gOLte2dwEFsHQLOw',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '1',
                    lineIndex: '3',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'too',
                    style: ['highlighted'],
                    id: 'krxj4und9p7w2X4J',
                    lineId: 'gOLte2dwEFsHQLOw',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '2',
                    lineIndex: '3',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['highlighted', 'nospacing'],
                    id: 'OHIVolFbKCoEkKCH',
                    lineId: 'gOLte2dwEFsHQLOw',
                    sectionId: 'HvZilrKquQzc4UYM',
                    wordIndex: '3',
                    lineIndex: '3',
                    sectionIndex: '1',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'gOLte2dwEFsHQLOw',
              },
            ],
            id: 'HvZilrKquQzc4UYM',
          },
          {
            type: 'section',
            lines: [
              {
                words: [
                  {
                    text: 'It',
                    id: 'gk6cTwqaagkWNoMF',
                    lineId: 'q2XX7UEt297JDZSq',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '0',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'is',
                    id: 'doYCSMp9p8G1jsBE',
                    lineId: 'q2XX7UEt297JDZSq',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '1',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'good',
                    id: '9aA7FwY1HkAGoek1',
                    lineId: 'q2XX7UEt297JDZSq',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '2',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'to',
                    id: 'yaYOHZx3LcfqGaDY',
                    lineId: 'q2XX7UEt297JDZSq',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '3',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'go',
                    id: 'Xty1hOUt8u9QgIE0',
                    lineId: 'q2XX7UEt297JDZSq',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '4',
                    lineIndex: '0',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'q2XX7UEt297JDZSq',
              },
              {
                words: [
                  {
                    text: 'to',
                    id: 'KzBc18xXlEY1eaz3',
                    lineId: 'nTDSPfaKGDY9Up1L',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '0',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'the',
                    id: 'fWqAFXAg64M3KjFy',
                    lineId: 'nTDSPfaKGDY9Up1L',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '1',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: 'beach',
                    id: 'RqZRFaki18mOmr6L',
                    lineId: 'nTDSPfaKGDY9Up1L',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '2',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                  {
                    text: '.',
                    style: ['nospacing'],
                    id: 'i5lb6NMhlWPv1eIL',
                    lineId: 'nTDSPfaKGDY9Up1L',
                    sectionId: 'Rqs6uM8Ga7xSnA2T',
                    wordIndex: '3',
                    lineIndex: '1',
                    sectionIndex: '2',
                    side: 'right',
                    hasDefaultLanguage: false,
                    type: 'section',
                    label: 'Words and Sentences',
                  },
                ],
                id: 'nTDSPfaKGDY9Up1L',
              },
            ],
            id: 'Rqs6uM8Ga7xSnA2T',
          },
        ],
      },
    },
  ],
  text_type: 'Information Report',
  collection: 'Emergent A',
  json_version: '1.0',
  teacher_focus: [
    {
      screen: 'Words',
      content:
        'Ask students to: \n - look carefully at the pictures and talk about _who_ or _what_ is in them \n - identify initial sounds or read the labels on each picture \n - use the labels and the words under the flap to make sentences.',
    },
    {
      screen: 'Sentences',
      content:
        ' - Revisit pages 32–33, _Learning About Words_. \n - Read the sentences to or with students, or allow them to read the sentences independently. \n Ask students to: \n - identify the sentence that tells what the information report is about \n - identify the sentences that tell _what_ beaches look like and _who_ or _what_ goes there \n - read the last sentence to find out _how_ the writer feels about beaches.',
    },
    {
      screen: 'Words and Sentences',
      content:
        ' - Revisit pages 32–33, _Learning About Words_, and pages 34–35, _Learning About Sentences_. \n - Read the text to or with students, or allow them to read it independently. Tell them that the writer has added more information. \n Ask students to: \n - identify the words or sentences that tell _what_ the information report is about \n - identify the sentences that tell _what_ beaches look like, _who_ or _what_ goes there and _what_ they do on the beaches \n - read the last sentence to find out _how_ the writer feels about beaches.',
    },
  ],
  relationships: {
    images: [
      {
        uuid: '96ce9fac-3044-41a8-947b-09706bb2215e',
        url: 'https://pmwri-media-dev.s3.ap-southeast-2.amazonaws.com/unit_tests/41/3201_pmw_em_a_57804.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAT35GAEBWQ4SVFT5W%2F20220202%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20220202T105724Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=faacbfa5d5a4c13a8316cde12b238114de32bdaa672fc29941a5e47986038096',
      },
      {
        uuid: '954678b0-79a3-4431-a3d6-8efa8d8595f0',
        url: 'https://pmwri-media-dev.s3.ap-southeast-2.amazonaws.com/unit_tests/42/3202_pmw_em_a_57804.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAT35GAEBWQ4SVFT5W%2F20220202%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20220202T105724Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=2c6e560e8feda1b0a1f437faebaebf3cd0fa7430c72ffac21488142dd1781f16',
      },
      {
        uuid: '0f603aec-ca5a-428e-873e-adcee6f6b9d5',
        url: 'https://pmwri-media-dev.s3.ap-southeast-2.amazonaws.com/unit_tests/43/3301_pmw_em_a_57804.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAT35GAEBWQ4SVFT5W%2F20220202%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20220202T105724Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=d63f4268602b4b9d9089cac48464ab0a6d7af00086d8ed622d5a55ebc7513e15',
      },
      {
        uuid: '85887e3d-e13d-4b0c-8fa3-5b6c94a7ebcc',
        url: 'https://pmwri-media-dev.s3.ap-southeast-2.amazonaws.com/unit_tests/44/3302_pmw_em_a_57804.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAT35GAEBWQ4SVFT5W%2F20220202%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20220202T105724Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=b1680ff15e0ad1ada32c45ed951f505e22aefa7fece6900064ee81a1053aadae',
      },
      {
        uuid: 'ac0453e4-a521-4d83-9d9b-d4b44694be2f',
        url: 'https://pmwri-media-dev.s3.ap-southeast-2.amazonaws.com/unit_tests/45/3302_pmw_em_a_57804.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAT35GAEBWQ4SVFT5W%2F20220202%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20220202T105724Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=ad5ce87aa25494d2528baec5e810902f1a8df3ba35ee1c18fca68da3b5b36027',
      },
      {
        uuid: '3c330fe3-0c84-46ef-ba8b-3257d5a20f92',
        url: 'https://pmwri-media-dev.s3.ap-southeast-2.amazonaws.com/unit_tests/46/3201_pmw_em_a_57804.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAT35GAEBWQ4SVFT5W%2F20220202%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20220202T105724Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=906fc38c4bfafa70588c051e502366dabbfe6a73e3e444ec5cf135b303f8a495',
      },
      {
        uuid: '60a0c63a-32f7-4d75-b904-e9d7d5a0a39a',
        url: 'https://pmwri-media-dev.s3.ap-southeast-2.amazonaws.com/unit_tests/47/3601_pmw_em_a_57804.jpg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAT35GAEBWQ4SVFT5W%2F20220202%2Fap-southeast-2%2Fs3%2Faws4_request&X-Amz-Date=20220202T105724Z&X-Amz-SignedHeaders=host&X-Amz-Expires=86400&X-Amz-Signature=bcc4a105d221e4f4e7db548281594877a329e97093a0c28701cc9215164ee6fe',
      },
    ],
  },
};

export const proforma = {
  content: {
    left: [
      {
        type: 'section',
        label: 'Title',
        lines: [
          {
            words: [
              {
                text: 'first',
              },
              {
                text: ' ',
              },
              {
                text: 'line',
              },
            ],
          },
          {
            words: [
              {
                text: 'second',
              },
              {
                text: '.',
                style: ['nospacing'],
              },
            ],
          },
        ],
      },
    ],
    right: [
      {
        type: 'image',
        uuid: '',
      },
    ],
  },
  section_labels: [
    {
      label: 'Title',
      help_text: 'help text',
      description: '',
    },
  ],
  language_feature_labels: [],
  relationships: {
    images: [
      {
        uuid: 'saved-image-uuid',
        url: 'image-url',
      },
    ],
  },
  stage: 'Early',
  id: 'id1',
};
export const writingProforma = {
  json_version: '1.0',
  title: '',
  stage: 'Early',
  text_type: 'Information Report',
  section_labels: [
    {
      label: 'Title',
      description: '',
      help_text: 'This is the help text that appears when the user selects the ? Icon.',
    },
    {
      label: 'General Statement',
      description: 'What are the living or non-living things?',
      help_text: 'This is the help text that appears when the user selects the ? Icon.',
    },
    {
      label: 'Description',
      description: 'What do they look like? What can they do?',
      help_text: 'This is the help text that appears when the user selects the ? Icon.',
    },
    {
      label: 'Evaluation',
      description: 'How does the writer feel about the topic?',
      help_text: 'This is the help text that appears when the user selects the ? Icon.',
    },
  ],
  language_feature_labels: [
    {
      label: 'Nouns',
      words: ['cat', 'ball', 'farm', 'animal'],
    },
    {
      label: 'Verbs',
      words: ['am', 'is', 'are'],
    },
    {
      label: 'Adjectives',
      words: ['run', 'swim', 'win', 'are'],
    },
    {
      label: 'Present-tense verbs',
      words: ['red', 'small', 'big', 'fast'],
    },
    {
      label: 'Time and sequence words',
      words: ['when', 'then', 'after', 'on the weekend', 'at last', 'now'],
    },
    {
      label: 'Conjunctions/Text connectives',
      words: ['at', 'at first', 'at first time', 'such', 'such as'],
    },
  ],
  content: {
    left: [
      {
        type: 'section',
        label: 'Title',
        style: ['heading'],
        lines: [
          {
            words: [],
          },
        ],
      },
      {
        type: 'section',
        label: 'General Statement',
        lines: [
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
        ],
      },
      {
        type: 'section',
        label: 'Description',
        lines: [
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
        ],
      },
    ],
    right: [
      {
        type: 'section',
        label: 'Description',
        lines: [
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
        ],
      },
      {
        type: 'section',
        label: 'Evaluation',
        lines: [
          {
            words: [],
          },
          {
            words: [],
          },
          {
            words: [],
          },
        ],
      },
      {
        type: 'image',
        url: '',
      },
    ],
  },
};

export const savedProformaAsProforma = {
  id: 1,
  textType: 'Recount',
  content: {
    stage: 'Early',
    title: 'IWP',
    content: {
      left: [
        {
          type: 'section',
          label: 'Title',
          lines: [
            {
              words: [
                {
                  text: 'some',
                  id: 'O4aAs4SstLv77diR',
                  lineId: 'etN8Vx5DDd0S17Uf',
                  sectionId: 'bZmAZX60TBHQVmVQ',
                  wordIndex: '0',
                  lineIndex: '0',
                  sectionIndex: '0',
                  side: 'left',
                  hasDefaultLanguage: false,
                },
                {
                  text: ' ',
                  id: 'VdwTtBE8QEJmRttB',
                  lineId: 'etN8Vx5DDd0S17Uf',
                  sectionId: 'bZmAZX60TBHQVmVQ',
                  wordIndex: '1',
                  lineIndex: '0',
                  sectionIndex: '0',
                  side: 'left',
                  hasDefaultLanguage: false,
                },
                {
                  text: 'text',
                  style: ['nospacing'],
                  id: 'Gl955X8hx1XgCbZa',
                  lineId: 'etN8Vx5DDd0S17Uf',
                  sectionId: 'bZmAZX60TBHQVmVQ',
                  wordIndex: '2',
                  lineIndex: '0',
                  sectionIndex: '0',
                  side: 'left',
                  hasDefaultLanguage: false,
                },
              ],
              id: 'etN8Vx5DDd0S17Uf',
            },
            { words: [], id: 'WJAL8bfmsPHlBt0F' },
          ],
          style: ['heading'],
          id: 'bZmAZX60TBHQVmVQ',
        },
        {
          type: 'section',
          label: 'Orientation',
          lines: [
            { words: [], id: 'SvdjYMfOjjy5Y9Iv' },
            { words: [], id: '0J5tRjo729BE6R3w' },
            { words: [], id: 'sztGNsUuGBS4x1uF' },
            { words: [], id: 'or4BtvpijA2qi5ku' },
          ],
          id: 'xd1gp6aPN3CVvDkX',
        },
        {
          type: 'section',
          label: 'Sequence of Events',
          lines: [
            { words: [], id: 'nfoujSfyNeMS18NY' },
            { words: [], id: 'bZjTadFmMqfoXp9K' },
            { words: [], id: 'VDJyk30h3IA9jEM1' },
            { words: [], id: 'q3eOM18azaNlnffo' },
            { words: [], id: 'kmU6iKaGwrCBpWD3' },
            { words: [], id: 'ah99bDIwHfPDOfYO' },
            { words: [], id: 'BehLU2XlOkuaowj0' },
            { words: [], id: 'QyjP34yDDZ4I6uK3' },
            { words: [], id: 'PRgyXGCwMqNnDhnP' },
            { words: [], id: '9ksX48ds58b4Lqks' },
          ],
          id: 'pOpBmA3WMYIJH95q',
        },
      ],
      right: [
        {
          type: 'section',
          label: 'Sequence of Events',
          lines: [
            { words: [], id: 'etjtQ44aYbbrF0ro' },
            { words: [], id: 'uaMIu3hvSmFWIvsj' },
            { words: [], id: 'M0y5j8UlBFaL2RDw' },
            { words: [], id: 'X9LpaNBVEPjgse6u' },
            { words: [], id: 'a8XmdksNJqXxeCPZ' },
            { words: [], id: 'CaDFSmzEJdGOAJSP' },
            { words: [], id: 'G2hdhFTGolJ7KNYM' },
            { words: [], id: 'chtD0UxkfLZ23nOj' },
            { words: [], id: 'GSxGDGDAF0QYe93N' },
            { words: [], id: 'DuBDo2kO7TVRGqaF' },
          ],
          id: 'KtVBCrp3SZoZD16Q',
        },
        {
          type: 'section',
          label: 'Personal Comment',
          lines: [
            { words: [], id: 'BurnE472qWtceVGa' },
            { words: [], id: 'pFX4nCdChL1yGCuP' },
            { words: [], id: 'N9CwEXFbvMb8s4Nn' },
          ],
          id: '5Tm6vvaKlZwdZbZp',
        },
        {
          type: 'image',
          isPlaceholder: true,
          editable: true,
          id: 'B2Oi5HkdHU9TXD8U',
          uuid: 'AWsH7wkF0dJPKF68',
        },
      ],
    },
    text_type: 'Recount',
    json_version: '1.0',
    section_labels: [
      {
        label: 'Title',
        help_text: 'What is this recount going to be about? What would be a good title for this recount?',
        description: '',
      },
      {
        label: 'Orientation',
        help_text:
          'What information needs to be included in the orientation? Who was involved? When did the events happen? Where did the events happen?',
        description: 'Who? When? Where?',
      },
      {
        label: 'Sequence of Events',
        help_text:
          'What information needs to be included in the sequence of events? What was the first thing that happened? What happened next? Then what happened? What time and sequence words can be used to order the events?',
        description: 'What happened?',
      },
      {
        label: 'Personal Comment',
        help_text: 'What needs to be included in the personal comment? How did the events make you feel?',
        description: 'How did the events make you feel?',
      },
    ],
    language_feature_labels: [
      { label: 'Nouns', words: [] },
      { label: 'Past-tense verbs', words: [] },
      { label: 'Time and sequence words', words: [] },
    ],
    thumbnail: '',
    relationships: exemplar.relationships,
  },
  page: null,
};

export const savedProcedureExemplar = {
  page: 'text-presentation',
  stage: 'Early',
  title: 'hidden',
  tools: {
    pen: {
      lines: [],
      isHidden: false,
    },
    notes: [],
    highlights: {
      isHidden: false,
    },
    isTextHidden: false,
  },
  content: {
    left: [
      {
        type: 'section',
        label: 'Title',
        lines: [
          {
            words: [
              {
                text: 'string',
                highlight: '#b2e2f8',
                id: 'AIDXoi1mScqnrKyn',
                lineId: 'RHgZvdfLBB0Yryte',
                sectionId: 'eppvzeWxRMP9bgv6',
                wordIndex: '0',
                lineIndex: '0',
                sectionIndex: '0',
                side: 'left',
                hasDefaultLanguage: false,
              },
            ],
            id: 'RHgZvdfLBB0Yryte',
          },
        ],
        style: ['heading'],
        id: 'eppvzeWxRMP9bgv6',
      },
      {
        type: 'image',
        uuid: '5615c6d2-f38e-4529-98b5-297db6b9286c',
        editable: true,
        isHidden: false,
        position: {
          x: 27,
          y: 40,
          width: 20,
          height: 30,
        },
        id: 'OeTOATALv436sPli',
      },
    ],
    right: [
      {
        type: 'image',
        uuid: 'dc16042f-68a5-422c-bcc1-8359223406a6',
        editable: true,
        isHidden: true,
        position: {
          x: 90,
          y: 15,
          width: 10,
          height: 25,
        },
        id: 'Rly6Lb5pLBTkryIL',
      },
      {
        type: 'image',
        uuid: 'd8c79b4b-31a8-4e72-9ccf-230195ba1a39',
        editable: true,
        isHidden: false,
        position: {
          x: 70,
          y: 53,
          width: 30,
          height: 47,
        },
        id: 'v54XigmOw00Gqrry',
      },
    ],
  },
  text_type: 'Procedure',
  thumbnail: '',
  collection: 'Early A',
  json_version: '1.0',
  teacher_focus: exemplar.teacher_focus,
  section_labels: exemplar.section_labels,
  language_feature_labels: exemplar.language_feature_labels,
  relationships: {
    images: [
      {
        uuid: '5615c6d2-f38e-4529-98b5-297db6b9286c',
        url: 'https://pmwri-media-qa.s3.ap-southeast-2.amazonaws.com/A',
      },
      {
        uuid: 'dc16042f-68a5-422c-bcc1-8359223406a6',
        url: 'https://pmwri-media-qa.s3.ap-southeast-2.amazonaws.com/B',
      },
      {
        uuid: 'd8c79b4b-31a8-4e72-9ccf-230195ba1a39',
        url: 'https://pmwri-media-qa.s3.ap-southeast-2.amazonaws.com/C',
      },
      {
        uuid: '012d1c19-2eda-4144-9a2c-b5fecf33815f',
        url: 'https://pmwri-media-qa.s3.ap-southeast-2.amazonaws.com/D',
      },
    ],
  },
};
